exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vert-timeline .event-timeline-dot .bx-fade-right{\n    color: #556ee6;\n}\n.verti-timeline .event-list {\n    padding: 0px 0px 15px 30px;\n}\np{\n    margin-bottom:0.5em !important;\n}\n.bx-fade-right {\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.event-list {\n    padding: 0px 0px 15px 30px;\n}\n.event-list-ar {\n    padding: 0px 30px 15px 30px !important;\n}\n.bolddriver {\n    font-weight : 600;\n}\n.tooltip {\n  max-width: none !important;\n}\n", ""]);

// exports
